module.exports = __webpack_public_path__ + "img/ff03_alt.f5c76322.svg";